module.exports = __webpack_public_path__ + "static/Hrishikesh_resume-51ea9b8a253651af01a67a3ccd60bfe3.pdf";